import { LOOKUP_REWARDS_TRANSPARENCY_POINTS_FOR_ITEM } from 'store/ducks/rewards/types';

export const onLookupRewardsTransparencyPointsForItem = () => ({
  type: LOOKUP_REWARDS_TRANSPARENCY_POINTS_FOR_ITEM
});
